import React, { useState } from "react";
import ErrorBoundary from "../../../ErrorBoundary";
import { FormGroup, Input, Label } from "reactstrap";

const SwitchCellRender = ({ rowData, columnName, updateRowValue }) => {
  console.log(rowData, "rowdat");
  const value = rowData[columnName] === "Y" ? true : false;

  const [check, setCheck] = useState(value);

  const handlerChange = (event) => {
    const { checked } = event.target;
    setCheck(checked);
    updateRowValue(checked ? "Y" : "N", columnName);
  };

  return (
    <div style={{ display: "flex", justifyContent: "flex-start" }}>
      <ErrorBoundary>
        <Label check className="toggle-label"></Label>
        <FormGroup switch>
          <Input
            type="switch"
            name={columnName}
            checked={check}
            onChange={handlerChange}
          />
        </FormGroup>
      </ErrorBoundary>
    </div>
  );
};

export default SwitchCellRender;
